const DEFAULT_MTU = 1200;
/**
 * Low-level transport.
 *
 * @remarks
 * The transport understands NDN TLV structures, but does not otherwise concern with packet format.
 */
export class Transport {
    attributes;
    /**
     * Constructor.
     * @param attributes - Attributes of the transport.
     */
    constructor(attributes) {
        this.attributes = attributes;
    }
    /**
     * Return the transport MTU.
     *
     * @remarks
     * The transport should be able to send TLV structure of up to this size.
     * If not overridden, return a conservative number.
     *
     * Note that this does not restrict incoming packet size.
     */
    get mtu() { return DEFAULT_MTU; }
    /* eslint-disable tsdoc/syntax -- tsdoc-missing-reference */
    /**
     * Reopen the transport after it has failed.
     * @returns The same transport or a new transport after it has been reconnected.
     *
     * @throws {@link \@ndn/l3face!Transport.ReopenNotSupportedError}
     * Thrown to indicate the transport does not support reopening.
     */
    /* eslint-enable tsdoc/syntax */
    // @link needs to be qualified with package name, otherwise TypeDoc will fail to resolve link
    // when this method is inherited into subclass without being overridden or without own TSDoc.
    reopen() {
        return Promise.reject(new Transport.ReopenNotSupportedError());
    }
    toString() {
        /* v8 ignore next */
        return this.attributes.describe ?? this.constructor.name;
    }
}
(function (Transport) {
    /**
     * Error thrown by {@link Transport.reopen} to indicate that reopen operation is not supported.
     * No further `.reopen()` should be attempted.
     */
    class ReopenNotSupportedError extends Error {
        constructor() {
            super("reopen not supported");
        }
    }
    Transport.ReopenNotSupportedError = ReopenNotSupportedError;
})(Transport || (Transport = {}));
